import { ifyouApi, kevinAuthAPI, STORY } from 'apis/config';

export const soundApis = {
  soundList: (projectId) =>
    kevinAuthAPI
      .get(`/resource-manager/sound/${projectId}`)
      .then((res) => res.data),
  soundTypes: (lang) =>
    kevinAuthAPI
      .get(`/common/localize/sound_type?lang=${lang}`)
      .then((res) => res.data),
  soundUpload: (projectId, data) =>
    kevinAuthAPI
      .post(`/resource-manager/sound/${projectId}`, data)
      .then((res) => res.data),
  soundUpdate: (projectId, id, data) =>
    kevinAuthAPI
      .patch(`/resource-manager/sound/${projectId}/${id}`, data)
      .then((res) => res.data),
  soundDelete: (projectId, id) =>
    kevinAuthAPI
      .delete(`/resource-manager/sound/${projectId}/${id}`)
      .then((res) => res.data),
};
